import request from '@/utils/request'

export function userVisit(data) {
    return request({
      url: 'product/userVisit',
      method: 'post',
      data
    })
  }
  